import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Moment from "moment";
import {numeral as Numeral} from "../utils";

import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
//import Card from '@mui/material/Card';
import Box from '@mui/material/Box';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

//import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
//import Divider from '@mui/material/Divider';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import validate from "validate.js";

import Toolbar from './Toolbar';
import DataContainer from './DataContainer';

import AuthContext from "./auth/Context";
import GroupTabs from "./GroupTabs";
import createConstraints from "./createConstraints";
import * as utils from "../utils";
import createDefaults from "./createDefaults";


import {gradientBackgroundStyle} from '../utils';


class Form extends React.Component{
  constructor(props){
    super(props);
    this.state={
      data:cloneDeep(this.props.data),
      load:0,
      activeStep:0,
      expanded:0,
      listInfo:this.props.listInfo,
    }
    this.handleValueChanged = this.handleValueChanged.bind(this);
    this.prepareFields = this.prepareFields.bind(this);
    this.getSteps = this.getSteps.bind(this);
    this.isHidden = this.isHidden.bind(this);
    this.getData = this.getData.bind(this);
    this.getMaster = this.getMaster.bind(this);
  }
  async componentDidMount(){
    if(!this.props.fields && !this.props.listInfo && this.props.code && !this.fields){
      const listInfo = await this.context.apis.asyncGetData(this.context.userInfo?this.context.getToken():this.context.config.public_token,"listinfo",{code:this.props.code.toLowerCase()},null,true,true);
      if(listInfo && listInfo.fields){
        //create default
        let {data} = this.state;
        if(Object.keys(data).length==0){
          let defaultData = {};
          await createDefaults(defaultData,listInfo.fields,this.context)
          data = {...defaultData,...data}
          this.setState({listInfo,data,load:this.state.load+1},async ()=>{
            await this.prepareFields(listInfo.fields);
          })
        }else{
          this.setState({listInfo});
          await this.prepareFields(listInfo.fields);
        }
      }
    }else{
      await this.prepareFields(this.props.fields || (this.props.listInfo||{}).fields);
    }
  }
  shouldComponentUpdate(nextProps,nextState){
    if(nextState.load!==this.state.load || nextState.activeStep!==this.state.activeStep || nextState.expanded!==this.state.expanded ) return true;
    
    if(!isEqual(nextProps.data,this.state.data)){
      //console.log("data updated on formbase:",this.props.code);
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state.data = cloneDeep(nextProps.data);
      this.prepareFields(nextProps.fields);
      return true;
    }
    if(!isEqual(nextProps.fields,this.props.fields)){
      //console.log("fields on formbase:",this.props.code);
      this.prepareFields(nextProps.fields);
      return true;
    }
    return false;
  }
  getData(){
    return this.state.data;
  }
  getMaster(){
    return this.props.master;
  }
  isHidden(field,master,data={},type="not_input"){
    if(!field[type]) return false;
    let expression = field[type].toString();
    if(expression.toLowerCase()==="true") return true;
    if(expression.toLowerCase()==="false") return false;
    try{
      expression = (expression.indexOf("return ")<0?"return ":"") + expression;
      const func= new Function("master","detail","context","mediaQueryMatches", expression);
      let rs =  func(master|| data,data,this.context,this.props.mediaQueryMatches);
      return rs;
    }catch(e){
      console.error(e,".Check expression:",expression);
      return false;
    }
  }

  async prepareFields(fields){
    if(!fields) return;
    //fields need to handle header
    await Promise.all((fields||[]).filter(f=>(f.header_source || f.header).indexOf("return ")>=0).map(field=>{
      return (async ()=>{
        let body_func = field.header_source || field.header;
        body_func =`return (async ()=>{
          ${body_func}
        })()`;
        try{
          const func  = new Function("master","Moment","Numeral","API","utils","context","field","listInfo",body_func);
          let header = await func(this.state.data||{},Moment,Numeral,this.context.apis,utils,this.context,field,{fields});
          field.header_source = field.header_source || field.header;
          field.header = header;
        }catch(e){
          console.error(e.message,field.header,body_func);
        }
      })();
    }));

    this.fields = cloneDeep(fields);
    if(this.props.readOnly){
      this.fields = this.fields.filter(field=>field.on_view);
    }
    this.fields.forEach(f=>{
      f.tab = f.tab||"";
      f.group = f.group||"";
      if(f.group===f.name && f.type==="Group") f.group ="";
      
      //if(!f.group && !f.tab && f.type!=="Group") f.tab = "master";
      if(!f.group && !f.tab) f.tab = "master";
    })
    this.setState({load:this.state.load+1});

  }
  async handleValueChanged(_data){
    let {data} = this.state;
    for(let key in _data){
      data[key] = _data[key];
    }
    this.setState({data,load:this.state.load+1});
    if(this.props.handleValueChanged) this.props.handleValueChanged(data);
  }
  getFieldsOfGroup(group){
    let fields= this.fields.filter(f=>f.group==group);

    let c_groups = fields.filter(f=>f.type=="Group");
    if(c_groups.lengt==0) return fields;
    for(let c_group of c_groups){
      let c_fields = this.getFieldsOfGroup(c_group.name);
      fields = [...fields,...c_fields];
    }

    return fields;
  }
  getFieldsOfTab(tab){
    //Tìm các field của tab. chỉ lấy các field là group hoặc các field không thuộc group
    let fieldsOftab = this.fields.filter(f=>f.tab===tab && (f.type==="Group" || !f.group));
    //Tìm các field là group
    for(let group of fieldsOftab.filter(f=>f.type=="Group")){
      //Tìm các field của group
      let fields_of_group = this.getFieldsOfGroup(group.name);
      //Các field của tab sẽ gồm các field không nằm trong group và các fields của group
      fieldsOftab = [...fieldsOftab,...fields_of_group];
    }
    return fieldsOftab;
  }
  getSteps(){
    let steps =[];
    this.fields.forEach(f=>{
        f.visible = (!this.isHidden(f,this.props.master,this.state.data,"not_input") && f.type!=="Link");
    })
    //
    this.masterFields = cloneDeep(this.getFieldsOfTab("master"));
    this.masterFields.forEach(f=>{
      f.tab ="";
    })
    this.summaryFields = cloneDeep(this.getFieldsOfTab("summary"));
    this.summaryFields.forEach(f=>{
      f.tab ="";
    })
    this.footerFields = cloneDeep(this.getFieldsOfTab("footer"));
    this.footerFields.forEach(f=>{
      f.tab ="";
    })

    let _fieldsTab = this.fields.filter(f=>!this.masterFields.find(m=>m.name==f.name) && !this.summaryFields.find(m=>m.name==f.name) && !this.footerFields.find(m=>m.name==f.name) );
    this.fieldsTab = _fieldsTab;
    
    //thong tin chung
    if(this.masterFields.filter(f=>f.visible).length>0){
      steps.push({
        label: "Thông tin chung",
        fields:this.masterFields,
        component:(
          <div key="master-session" class="flex-master-session">
            <GroupTabs
              idApp={this.props.idApp}
              code = {this.props.code}
              orientation ={this.props.orientationTab}
              backgroundColorBar={this.props.backgroundColorBarTab}
              backgroundColorFields={this.props.backgroundColorFieldsTab}
              showFieldName={this.props.showFieldName}
              style={{maxHeight:(this.props.style||{}).maxHeight}}
              name="master"
              //style={{padding:5}}
              master={this.props.master}
              data={this.state.data} 
              fields={this.masterFields}
              group={""}
              readOnly={this.props.readOnly}
              noValidate = {this.props.noValidate}
              dataPickers = {this.props.dataPickers}
              parent = {this.props.parent}
              mainForm={this}

              mediaQueryMatches ={this.props.mediaQueryMatches}
              handleValueChanged={this.handleValueChanged.bind(this)}/>
          </div>
        )
      })
    }
    //thong tin chi tiet
    const fieldsTab = this.fieldsTab.filter(f=>f.visible);
    if(fieldsTab.length>0){
      let tabs = [...new Set(fieldsTab.sort((a,b)=>(a.stt||0)-(b.stt||0)).map(f=>f.tab).filter(t=>t))];
      if(this.props.mediaQueryMatches){
        tabs.forEach((tab,index)=>{
          //let fieldsOfTab = this.fieldsTab.filter(f=>f.tab===tab);
          let fieldsOfTab = this.getFieldsOfTab(tab);
          steps.push({
            label:tab,
            fields:fieldsOfTab,
            component:(
              <div  key={"root-tabs-session" + index}  class={"flex-tabs-session " + index} style={{flexGrow:1,flex:1}}>
                <GroupTabs
                  idApp={this.props.idApp}
                  code = {this.props.code}
                  name="detail"
                  orientation ={this.props.orientationTab}
                  backgroundColorBar={this.props.backgroundColorBarTab}
                  backgroundColorFields={this.props.backgroundColorFieldsTab}
                  showFieldName={this.props.showFieldName}
                  style={{maxHeight:(this.props.style||{}).maxHeight}}
                  master={this.props.master}
                  data={this.state.data} 
                  fields={fieldsOfTab}
                  group={""}
                  readOnly={this.props.readOnly}
                  noValidate = {this.props.noValidate}
                  dataPickers = {this.props.dataPickers}
                  parent = {this.props.parent}
                  mainForm={this}

                  mediaQueryMatches ={this.props.mediaQueryMatches}
                  handleValueChanged={this.handleValueChanged.bind(this)}/>
              </div>
            )
          })
        })
      }else{
        steps.push({
          label:"Chi tiết",
          fields:this.fieldsTab,
          component:(
            <div  key="root-tabs-session" class="flex-tabs-session" style={{flexGrow:1,flex:1,overflow:"auto"}}>
              <GroupTabs
                idApp={this.props.idApp}
                code = {this.props.code}
                orientation ={this.props.orientationTab}
                backgroundColorBar={this.props.backgroundColorBarTab}
                backgroundColorFields={this.props.backgroundColorFieldsTab}
                showFieldName={this.props.showFieldName}
                style={{height:"100%",maxHeight:(this.props.style||{}).maxHeight}}
                name="detail"
                master={this.props.master}
                data={this.state.data}
                fields={this.fieldsTab}
                group={""}
                readOnly={this.props.readOnly}
                noValidate = {this.props.noValidate}
                dataPickers = {this.props.dataPickers}
                parent = {this.props.parent}
                mainForm={this}

                mediaQueryMatches ={this.props.mediaQueryMatches}
                handleValueChanged={this.handleValueChanged.bind(this)}/>
            </div>
          )
        })
      }
    }
    if(this.summaryFields.filter(f=>f.visible).length>0){
      steps.push({
        label:"Tóm tắt",
        fields:this.summaryFields,
        component:(
          <>
            <div key="summary-session" class="flex-summary-session" style={{borderTop:!this.props.mediaQueryMatches?"1px dotted silver":undefined,backgroundColor:(this.props.mediaQueryMatches?undefined:"#f5f5f5")}}>
              <Grid container justifyContent="space-between" alignItems="flex-end">
              {!!this.state.data.user_created && !this.props.mediaQueryMatches &&
                <Grid
                  style={{padding:10,paddingRight:30}}
                  size={{
                    xs: 12,
                    sm: 12,
                    md: 3,
                    lg: 3
                  }}>
                  <Typography component='div'><small><i style={{fontSize:9}}>{`${this.context.apis.getLabel("Tạo bởi ")} ${this.state.data.user_created.split("@")[0]} ${this.context.apis.getLabel("lúc")} ${Moment(this.state.data.date_created).format("DD/MM/YY HH:mm A")}`}</i></small></Typography>
                  <Typography component='div'><small><i style={{fontSize:9}}>{`${this.context.apis.getLabel("Cập nhật bởi ")} ${this.state.data.user_updated.split("@")[0]} ${this.context.apis.getLabel("lúc")} ${Moment(this.state.data.date_updated).format("DD/MM/YY HH:mm A")}`}</i></small></Typography>
                </Grid>
              }
                <Grid
                  size={{
                    xs: 12,
                    sm: 12,
                    md: !!this.state.data.user_created && !this.props.mediaQueryMatches?9:12,
                    lg: !!this.state.data.user_created && !this.props.mediaQueryMatches?9:12
                  }}>
                  <GroupTabs
                      idApp={this.props.idApp}
                      code = {this.props.code}
                      name="summary"
                      justify="flex-end"
                      orientation ={this.props.orientationTab}
                      backgroundColorBar={this.props.backgroundColorBarTab}
                      backgroundColorFields={this.props.backgroundColorFieldsTab}
                      showFieldName={this.props.showFieldName}
                      style={{maxHeight:(this.props.style||{}).maxHeight}}
                      master={this.props.master}
                      data={this.state.data} 
                      fields={this.summaryFields}
                      group={""}
                      readOnly={this.props.readOnly}
                      noValidate = {this.props.noValidate}
                      dataPickers = {this.props.dataPickers}
                      parent = {this.props.parent}
                      mainForm={this}

                      mediaQueryMatches ={this.props.mediaQueryMatches}
                      handleValueChanged={this.handleValueChanged.bind(this)}/>
                </Grid>
              </Grid>
            </div>
            {this.footerFields.length>0 &&
              <div key="footer-session"  class="flex-footer-session">
                <GroupTabs
                    idApp={this.props.idApp}
                    code = {this.props.code}
                    name="footer"
                    orientation ={this.props.orientationTab}
                    backgroundColorBar={this.props.backgroundColorBarTab}
                    backgroundColorFields={this.props.backgroundColorFieldsTab}
                    showFieldName={this.props.showFieldName}
                    style={{maxHeight:(this.props.style||{}).maxHeight}}
                    //style={{padding:5}}
                    master={this.props.master}
                    data={this.state.data} 
                    fields={this.footerFields}
                    group={""}
                    readOnly={this.props.readOnly}
                    noValidate = {this.props.noValidate}
                    dataPickers = {this.props.dataPickers}
                    parent = {this.props.parent}
                    mainForm={this}

                    mediaQueryMatches ={this.props.mediaQueryMatches}
                    handleValueChanged={this.handleValueChanged.bind(this)}/>
              </div>
            }
          </>
        )
      })
    }
    return steps;
  }
  handleNext(){
    //check valid
    let  constraints = createConstraints(this.steps[this.state.activeStep].fields||[],this.context);
    let valid = validate(this.state.data, constraints,{format: "flat"});
    if(valid){
      let error=valid.join("<br/>");
      this.context.alert(error);
      return;
    }
    //
    let {activeStep} = this.state;
    if(activeStep<this.steps.length-1){
      activeStep = activeStep+1;
    }
    this.setState({activeStep})
  }
  handleBack(){
    let {activeStep} = this.state;
    if(activeStep===0){
      if(this.props.handleClose) this.props.handleClose();
      return;
    }
    if(activeStep>0){
      activeStep = activeStep-1;
    }
    this.setState({activeStep})
  }
  handleSave(){
    if(this.props.handleSave){
      this.props.handleSave();
    }
  }
  handleDelete(){
    if(this.props.handleDelete){
      this.props.handleDelete();
    }
  }
  handleClose(){
    if(this.props.handleClose){
      this.props.handleClose();
    }
  }
  renderSteps(){
    if(!this.fields) return null;
    let steps = this.steps;
    if(steps.length==0) return null;

    let {activeStep} = this.state;
    let maxSteps = steps.length;
    let label = steps[activeStep].label;
    if(steps.length==1 && this.state.listInfo){
      label = this.state.listInfo.title;
    }
    const {listInfo} = this.state;
    let save_label = listInfo && listInfo.options && listInfo.options.props && listInfo.options.props.save_label? listInfo.options.props.save_label:"Tạo";

    return (
      <div style={this.props.style}  class="flex-formbase flex-formbase-steps">
          <div style={{display:"flex",flexDirection:"column",width:"100%",height:"100%",position:"relative"}}>
            <div style={{backgroundColor:"#ddd"}}>
              <Typography variant="h5" style={{margin:10}}>{this.context.apis.getLabel(label)}</Typography>
            </div>
            <div style={{flex:1,flexGrow:1,overflowY:"auto",backgroundColor:"#f5f5f5"}}>
              {steps[activeStep].component} 
            </div>
            <div style={{paddingBottom:10,paddingTop:10,backgroundColor:"#ddd"}}>
              <div style={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
                  <Button 
                    startIcon={activeStep==0?<CloseIcon/>:<KeyboardArrowLeft />}
                    size="large"
                    variant="contained" 
                    color="secondary"
                    style={{marginRight:5}} onClick={this.handleBack.bind(this)}>
                    
                    <Typography noWrap>{this.context.apis.getLabel(activeStep==0?"Thoát":"Quay lại")}</Typography>
                  </Button>
                  {activeStep !== maxSteps - 1 && 
                  <Button
                    startIcon={<KeyboardArrowRight />}
                    size="large"
                    variant="contained"
                    color="secondary"
                    onClick={this.handleNext.bind(this)}
                    style={{marginRight:5}}
                  >
                    <Typography noWrap>{this.context.apis.getLabel("Tiếp")}</Typography>
                  </Button>}

                  {this.props.handleSave  &&  (activeStep==maxSteps - 1 || this.state.data._id)  && 
                  <Button
                    startIcon={<SaveIcon />}
                    size="large"
                    variant="contained"
                    color="primary"
                    onClick={this.handleSave.bind(this)}
                  >
                    <Typography noWrap>{this.context.apis.getLabel(this.state.data._id?"Cập nhật":save_label)}</Typography>
                  </Button>}
                </div>
            </div>
          </div>
      </div>
    )
  }
  renderAccordion(){
    let steps = this.steps;
    const maincolor = (this.props.backgroundColor||this.context.config.backgroundColor ||this.context.config.secondaryColor);
    const bg = gradientBackgroundStyle(maincolor,{brightenFirst:this.props.brightenFirst || this.context.config.fragBrightenFirst ||50,brightenSecond:this.context.config.fragBrightenSecond});
    const {listInfo} = this.state;
    const save_label = listInfo && listInfo.options && listInfo.options.props && listInfo.options.props.save_label? listInfo.options.props.save_label:"Tạo";
    //const {style:cardStyle,...cardProps} = this.context.config.cardProps||{}
    return <DataContainer
        style={{height:"100%"}}
        scrollable={this.props.mediaQueryMatches}
        hideHeaderWhenScollUp={false}
        footer={<>
          {(!!this.props.handleClose || !!this.props.handleSave || !!this.props.handleDelete) &&      
            <Toolbar position="bottom">
                {!!this.props.handleClose && <Button 
                  glass
                  variant="contained" 
                  color="secondary"
                  startIcon={<KeyboardArrowLeft />}
                  sx={{mr:2}} onClick={this.handleBack.bind(this)}>
                    {this.context.apis.getLabel("Quay lại")}
                </Button>}
              
                {!!this.props.handleSave && !this.props.readOnly && 
                <Button
                  glass
                  variant="contained"
                  color="primary"
                  sx={{mr:2}}
                  startIcon={<SaveIcon />}
                  onClick={this.handleSave.bind(this)}
                >
                  {this.context.apis.getLabel("Lưu")}
                </Button>}

                {this.state.data._id && this.props.handleDelete  && !this.props.readOnly && 
                  <Button
                    glass
                    variant="contained"
                    color="secondary"
                    onClick={this.handleDelete.bind(this)}
                    startIcon={<DeleteIcon />}
                  >
                    {this.context.apis.getLabel("Xoá")}
                  </Button>}
              </Toolbar>
                
          }
        </>}
      >
            <div style={{...this.props.style,display:"flex",flexDirection:"column",width:"100%",height:"100%"}}  class="flex-formbase flex-formbase-form-sm">
              <div style={{flex:1,overflow:"auto",...bg}}>
                {steps.map((s,index)=>{
                  const label = s.label || "Khác";
                  const fields = s.fields;
                  let p;
                  ///const _style={...cardStyle};
                  if(fields.find(f=>f.type=="Array" && f.form) && !fields.find(f=>f.type!=="Array" && f.type!=="Action" && f.type!=="Link")){
                    p = 0;
                  }
                  return (
                    <Accordion expanded={this.state.expanded ===index} onChange={()=>this.setState({expanded:this.state.expanded==index?-1:index})} key={index.toString()}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                      >
                        <Typography component="span">
                          {this.context.apis.getLabel(label)}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={{p,pt:0,borderTop:"1px solid #ddd"}}>
                        {/*<Card style={_style} {...cardProps}>
                            {s.component}
                        </Card>*/}
                        {s.component}
                      </AccordionDetails>
                    </Accordion>
                  )
                })}
              </div>
              
          </div>
    </DataContainer>
    
  }
  renderForm(){
    let steps = this.steps;
    let {listInfo} = this.state
    let save_label = listInfo && listInfo.options && listInfo.options.props && listInfo.options.props.save_label? listInfo.options.props.save_label:"Tạo";
    if(steps.length==0) return null;
    if(this.props.mediaQueryMatches || (window && window.innerWidth<700)){
      if(!this.context.queryParams?.for_agent && steps.length>1 ){
        return this.renderAccordion();
      }
      return (
        <DataContainer
          style={{height:"100%"}}
          scrollable={this.props.mediaQueryMatches}
          hideHeaderWhenScollUp={false}
          footer={<>
            {(!!this.props.handleClose || !!this.props.handleSave || !!this.props.handleDelete) &&      
              <Toolbar position="bottom">
                {!!this.props.handleClose && <Button 
                  glass
                  variant="contained" 
                  color="secondary"
                  startIcon={<KeyboardArrowLeft />}
                  sx={{mr:2}} onClick={this.handleBack.bind(this)}>
                    {this.context.apis.getLabel("Quay lại")}
                </Button>}
              
                {!!this.props.handleSave && !this.props.readOnly && 
                <Button
                  glass
                  variant="contained"
                  color="primary"
                  sx={{mr:2}}
                  startIcon={<SaveIcon />}
                  onClick={this.handleSave.bind(this)}
                >
                  {this.context.apis.getLabel("Lưu")}
                </Button>}

                {this.state.data._id && this.props.handleDelete  && !this.props.readOnly && 
                  <Button
                    glass
                    variant="contained"
                    color="secondary"
                    onClick={this.handleDelete.bind(this)}
                    startIcon={<DeleteIcon />}
                  >
                    {this.context.apis.getLabel("Xoá")}
                  </Button>}
              </Toolbar>
                  
                }
          </>}
        >
        <div style={{flex:1,overflow:"auto",paddingBottom:70}}>
          {steps.map((s,index)=>{
            let label = s.label;
            return (
              <Box key={index.toString()} sx={{p:1.5}}>
                {steps.length>1 && <div style={{padding:5}}>
                  <div style={{borderBottom:"1px solid #ddd",display:"flex",flexDirection:"row",alignItems:"center"}}>
                    <Typography variant="h5" style={{borderBottom:"2px solid " + this.context.config.primaryColor}}>{this.context.apis.getLabel(label)}</Typography>
                  </div>
                </div>}
                {s.component}
              </Box>
            )
          })}
        </div>
      </DataContainer>
        /*<div style={{...this.props.style,display:"flex",flexDirection:"column",width:"100%",height:"100%"}}  class="flex-formbase flex-formbase-form-sm">
            <div style={{flex:1,overflow:"auto",paddingBottom:70}}>
              {steps.map((s,index)=>{
                let label = s.label;
                return (
                  <Box key={index.toString()} sx={{p:1.5}}>
                    {steps.length>1 && <div style={{padding:5}}>
                      <div style={{borderBottom:"1px solid #ddd",display:"flex",flexDirection:"row",alignItems:"center"}}>
                        <Typography variant="h5" style={{borderBottom:"2px solid " + this.context.config.primaryColor}}>{this.context.apis.getLabel(label)}</Typography>
                      </div>
                    </div>}
                    {s.component}
                  </Box>
                )
              })}
            </div>
            {(!!this.props.handleClose || !!this.props.handleSave || !!this.props.handleDelete) &&   <div style={{
              paddingBottom:15,
              paddingTop:15,
              backgroundColor:"rgba(221, 221, 221,1)",
              bottom: 0,
              left: 0,
              right: 0,
              position: "absolute",
              zIndex:9999
            }}>
              <div style={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
                  {!!this.props.handleClose && <Button 
                    size="large"
                    variant="contained" 
                    color="secondary"
                    style={{marginRight:10}} onClick={this.handleBack.bind(this)}>
                      <KeyboardArrowLeft />
                  </Button>}
                
                  {!!this.props.handleSave && !this.props.readOnly && 
                  <Button
                    startIcon={<SaveIcon />}
                    size="large"
                    variant="contained"
                    color="primary"
                    style={{marginRight:10}}
                    onClick={this.handleSave.bind(this)}
                  >
                    <Typography noWrap>{this.context.apis.getLabel(this.state.data._id?"Cập nhật":save_label)}</Typography>
                  </Button>}

                  {this.state.data._id && this.props.handleDelete  && !this.props.readOnly && 
                    <Button
                     
                      size="large"
                      variant="contained"
                      color="secondary"
                      onClick={this.handleDelete.bind(this)}
                    >
                      <DeleteIcon />
                    </Button>}
                </div>
            </div>}
        </div>*/
      )
    }else{
      return (
        <div style={this.props.style}  class="flex-formbase flex-formbase-form-lg">
            <div style={{display:"flex",flexDirection:"column",width:"100%",height:"100%",overflow:"auto"}}>
              {steps.map(s=>{
                return s.component;
              })}
            </div>
        </div>
      )
    }
    
  }
  render(){
    if(!this.fields) return null;
    this.steps = this.getSteps();
    if(this.props.renderAccordion) return this.renderAccordion();
    return this.props.multiPages?this.renderSteps():this.renderForm()
  }
}
Form.contextType = AuthContext;
Form.propTypes={
  code:PropTypes.string,
  idApp:PropTypes.string,
  fields:PropTypes.arrayOf(PropTypes.object),
  listInfo:PropTypes.object,
  orientationTab:PropTypes.oneOf(["vertical","horizontal"]),
  backgroundColorBarTab:PropTypes.string,
  backgroundColorFieldsTab:PropTypes.string,

  handleValueChanged:PropTypes.func.isRequired,
  data:PropTypes.object,
  master:PropTypes.object,
  dataPickers:PropTypes.object,
  noValidate:PropTypes.bool,
  history:PropTypes.any,
  parent:PropTypes.any,
  readOnly:PropTypes.bool,
  multiPages:PropTypes.bool,
  renderAccordion:PropTypes.bool,
  style:PropTypes.any,
  mediaQueryMatches:PropTypes.bool,
  handleDelete:PropTypes.func,
  handleSave:PropTypes.func,
  handleClose:PropTypes.func,
}
export default Form;
